export default function (context, val) {
    context.commit('set_form', {
        Name: val,
        NameLat: window.app.$.translit(val),
    });
}